import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { ImportPage } from "@/components/migrations/import-page";

// Configuración → Migraciones: traer a la nube una empresa de Heskala Escritorio (ZIP
// `heskala.export`). Solo administradores; la página y el servidor lo exigen.
export const Route = createFileRoute("/_authenticated/settings/_layout/migrations")({
  component: MigrationsSettingsPage,
});

function MigrationsSettingsPage() {
  return (
    <RouteGuardPermissions permissions={[{ module: "custom_fields", actions: ["read"] }]}>
      <ImportPage />
    </RouteGuardPermissions>
  );
}
